import { useState } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Buton } from "@koclukpanel/ui";
import { gorunumBitir, type Ben } from "./api";
import { Hesabim } from "./Hesabim";
import { Kvkk } from "./Kvkk";

export function OnayKilidi({ ben, onCikis }: { ben: Ben; onCikis: () => void }) {
  const qc = useQueryClient();
  const [guvenlik, setGuvenlik] = useState(false);
  const don = useMutation({
    mutationFn: gorunumBitir,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["ben"] }),
  });
  return (
    <main className="mx-auto flex max-w-3xl flex-col gap-4 p-4">
      {ben.gorunumde ? (
        <>
          <h1 className="text-xl font-semibold">Kendi hesabınızın onayları bekleniyor</h1>
          <Buton onClick={() => don.mutate()} disabled={don.isPending}>
            Kendi hesabıma dön
          </Buton>
          {don.isError && <p role="alert">{don.error.message}</p>}
        </>
      ) : (
        <>
          <h1 className="text-xl font-semibold">
            Kullanıma devam etmek için onaylarınızı tamamlayın
          </h1>
          <Buton gorunum="ikincil" onClick={() => setGuvenlik(!guvenlik)}>
            {guvenlik ? "Onaylarıma dön" : "Hesap güvenliği"}
          </Buton>
          {guvenlik ? <Hesabim yalnizGuvenlik /> : <Kvkk />}
        </>
      )}
      <Buton gorunum="sessiz" onClick={onCikis}>
        Çıkış
      </Buton>
    </main>
  );
}
